import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IAffiliateUpdateSubaffiliateConditionPayload, IAffiliateUpdateSubaffiliateConditionResponse } from '../types';
import {
  AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_API_URL,
  AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_MUTATION,
  AFFILIATE_SUBAFFILIATE_SETTINGS,
} from '../constants';

export default function useAffiliateSubaffiliateConditionCreateMutation(): IContextMutationResult<
  IAffiliateUpdateSubaffiliateConditionResponse,
  Error,
  IAffiliateUpdateSubaffiliateConditionPayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<IAffiliateUpdateSubaffiliateConditionResponse, Error, IAffiliateUpdateSubaffiliateConditionPayload>({
    mutationKey: [AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_MUTATION],
    mutationFn: (payload) => fetchPost<IAffiliateUpdateSubaffiliateConditionResponse>(
      AFFILIATE_CREATE_SUBAFFILIATE_CONDITION_API_URL,
      payload,
      {
        permission: AFFILIATE_SUBAFFILIATE_SETTINGS.HISTORY_CHANGES_CREATE,
      },
    ),
    onSuccess() {
      displayPresetToast('created');
    },
  });
}
